<div [kalLoading]="loading">
    <kal-form-field>
        <kal-input (iconClicked)="refresh()"
                   [errorsMessage]="errorsMessages"
                   [formControl]="control"
                   [label]="label"
                   icon="refresh"
                   id="shared_part_number">
        </kal-input>

        <p *ngIf="!!lastPartNumber && lastPartNumber !== '0' && control.valid">
            <span>Dernier n° de pièce : {{lastPartNumber}}</span>
        </p>

    </kal-form-field>
</div>
